module.exports = __webpack_public_path__ + "img/levels-of-detail.zh_cn.e2a672f4.png";